<template>
	<div class="bshow_wrapper" :style="{'background': '#fff url('+imgUrl+'bshow_bg.png) no-repeat -207px -406px'}">
		<div class="notice_cont_outer">
			<div class="notice_title">
				<div class="m_outer">
					<div class="m_title">企业橱窗</div>
					<div class="m_tip">
						目前共有{{total}}家企业
					</div>
				</div>
			</div>
		</div>
		<div class="bsdetail_outer">
    		<div class="cur_pos">当前位置：<span class="linkto" @click="tohome">首页</span><img :src="imgUrl+'double_arrow.png'"/><span class="linkto" @click="toBshow">企业橱窗</span><img :src="imgUrl+'double_arrow.png'"/><span>详情</span></div>

			<div class="bsdetail_cont">
				<div class="head">
					<div>
						<img :src="detail.logo"/>
					</div>
					<div style="margin-left:12px;">
						<div class="nam" v-text="detail.post_title"></div>
						<div class="ws" v-text="'企业网址：'+detail.url" @click="toWS(detail.url)"></div>
					</div>
				</div>
				<div class="p_item">
					<div class="h4">企业简介</div>
					<div v-html="detail.post_content">
					</div>
				</div>
				<div class="p_item" style="display:none">
					<div class="h4">品牌介绍</div>
					<div v-html="detail.post_excerpt">
					</div>
				</div>
				<div class="p_item" v-if="detail.photos.length">
					<div class="h4">企业图片</div>
					<el-carousel indicator-position="outside" >
					    <el-carousel-item v-for="item in detail.photos" :key="item" class="carousel_item">
					      <div class="img_wrapper">
					      	<img :src="item.url"/>
					      </div>
					    </el-carousel-item>
					</el-carousel>
				</div>
				<div class="p_item" v-if="detail.products.length">
					<div class="h4">主要产品</div>
					<div class="product_outer">
						<div class="item" v-for="item in detail.products">
							<div class="img_wrapper" >
								<img :src="item.url"/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
	    created() {
	      let id = this.$route.query.id;
	      let total=this.$route.query.total;
	      if(total!==null && total!==undefined){
	        this.total=total;
        }
	      this.$ajax.get(this.bUrl+'api/portal/articles/read?id=' + id)
	        .then(function (res) {
	          this.detail=res.data.data;
	        }.bind(this))
	        .catch(function (error) {
	          console.log(error);
	        });
	    },
		name:'bsdetail',
		data(){
			return {
			  total:0,
			  detail: {
			      post_title: "",
			      published_time: "",
			      post_content: "",
			      post_excerpt: "",
			      logo: "",
			      url: "",
			      photos: [],
			      products: []
			    },
			}
		},
    watch: {
      $route(to, from) {
        let id = to.query.id;
        this.$ajax.get(this.bUrl+'api/portal/articles/read?id=' + id)
          .then(function (res) {
            this.detail=res.data.data;
          }.bind(this))
          .catch(function (error) {
            console.log(error);
          });
      }
    },

		methods:{
			toBshow() {
		      this.$router.push({name: 'bshow'})
		    },
		    tohome() {
		      this.$router.push({name: 'homepage'})
			},
			toWS(url){
				if(url.indexOf('http')<0){
					url='http://'+url
				}
				window.open(url)
			}
		},
	}
</script>

<style scoped>

	.notice_cont_outer{
		width: 1180px;
		margin: 0 auto;
	}
	.notice_title{
		height: 328px;
		display: flex;
		align-items: flex-end;
		position: relative;
	}

	.m_outer{
		padding: 20px;
	}
	.m_title{
		color: #fff;
		font-size: 28px;
		margin-bottom: 16px;
	}
	.m_tip{
		width: 350px;
		color: #fff;
		font-size: 14px;
		line-height: 24px;
		margin-top: 16px;
		margin-bottom: 16px;
	}

	.bsdetail_outer{
		background: #fff;
	}
	.bsdetail_cont{
		width: 1180px;
		margin:0 auto;
		padding:0 77px 77px 77px;
		box-sizing: border-box;
	}
	.bsdetail_cont .head{
		display: flex;
		align-items: center;
	}
	.bsdetail_cont .head img{
		width: 100px;
	}
	.bsdetail_cont .head .nam{
		color: #6F88AF;
		font-size: 24px;
	}
	.bsdetail_cont .head .ws{
		cursor: pointer;
		color: #343231;
		margin-top: 10px;
	}
	.bsdetail_cont .head .ws:hover{
		color: #399EFF;
	}
	.bsdetail_cont .p_item{
		margin-top: 50px;
	}
	.bsdetail_cont .p_item .h4{
		margin-bottom: 14px;
		color: #143367;
		font-size: 20px;
	}

	.carousel_item .img_wrapper{
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.carousel_item .img_wrapper img{
		max-height: 520px;
		max-width: 1020px;
	}
	.product_outer{
		display: flex;
		align-items: center;
		flex-wrap: wrap;
	}
	.product_outer .img_wrapper{
		width: 230px;
		height: 230px;
		margin-right: 34px;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		justify-content: center;
		background: #F8F8F8;
	}
	.product_outer .item:nth-child(4n) .img_wrapper{
		margin-right: 0;
	}
	.product_outer .img_wrapper img{
		max-height: 230px;
		max-width: 230px;
	}
	.product_outer .pro_name{
		line-height: 40px;
		margin-bottom: 10px;
	}
</style>



// WEBPACK FOOTER //
// src/components/BusinessShow/bsdetail.vue